import * as React from "react";
import { Button, Typography, Box, Container } from '@mui/material';
import Grid from '@mui/material/Grid2';
import theme from 'utils/theme';
import stars from 'images/lottie-fakes/lets-collab-stars.svg';
import Link from 'components/Link';
import Sunrise from 'components/Sunrise';

const LetsCollaborate = () => {
	const gridItemStyle = {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
		gap: '38.5px',

		paddingTop: '150px',
		paddingBottom: '150px',
		// [theme.breakpoints.down('laptop')]: {
		// 	paddingTop: '102px',
		// 	paddingBottom: '137px',
		// }
	};

	const backgroundStyle = {
		background: `url(${stars})`,
        backgroundSize: 'contain',
        backgroundPosition: 'top',
		backgroundRepeat: 'no-repeat',
		[theme.breakpoints.down('laptop')]: {
			// background: 'none',
			// backgroundSize: 'auto',
		}
	};

	return (
		<>
		<Box sx={backgroundStyle} component={'section'}>
			<Container>
				<Grid container justifyContent={'center'}>
					<Grid sx={gridItemStyle} size={{ xs: 9, sm: 7 }}>
						<Typography variant={'h1MastheadTitle'}>Let's Collaborate</Typography>
						<Button component={Link} href="/contact/" variant={'contained'}>Get In Touch</Button>
					</Grid>
				</Grid>
			</Container>
		</Box>
		<Sunrise />
		</>
	);
};

export default LetsCollaborate;